import { createContext, useContext, useLayoutEffect } from 'react'

export const PlayPresentationContext = createContext<{
  standard: boolean
  registerImmersive: () => () => void
} | null>(null)

export function usePlayPresentation() {
  return useContext(PlayPresentationContext)
}

// The view owns its presentation, including flows whose stages share a URL.
export function useImmersivePlayShell(active = true) {
  const register = usePlayPresentation()?.registerImmersive
  useLayoutEffect(() => {
    if (active && register) return register()
  }, [active, register])
}
